<mat-toolbar color="accent" class="expanded-toolbar"> 

<div>
	<button mat-button fxHide="false" *ngIf="this.appData.isLeftNavActive.value" (click)="toggleMenu()"
		fxHide.gt-sm>
		<mat-icon>menu</mat-icon>
	</button>

	<button mat-button (click)="redirectToHome()">{{home}}</button>
	<button mat-button (click)="redirectToHome()">
		<mat-icon>home</mat-icon>
	</button>
</div>



<button mat-button [mat-menu-trigger-for]="menu" fxHide="false"
	fxHide.gt-sm>
	<mat-icon>menu</mat-icon>
</button>



<div fxLayout="row" fxShow="false" fxShow.gt-sm>
	<button mat-button routerLink="/signup" *ngIf="!isAuthenticated">
		<mat-icon>gamepad</mat-icon>
		Sing up
	</button>
	<button mat-button routerLink="/login" *ngIf="!isAuthenticated">
		<mat-icon>power_settings_new</mat-icon>
		Login
	</button>
	<button *ngIf="isAuthenticated" mat-button [mat-menu-trigger-for]="matMenuAfterLogin" fxHide="false" fxHide.gt-sm>
		<mat-icon>account_box</mat-icon>
	</button>
	<button mat-button fxHide="false" *ngIf="this.appData.isRightNavActive.value" (click)="toggleRightMenu()"
		fxHide.gt-sm>
		<mat-icon>menu</mat-icon>
	</button>		
</div>

</mat-toolbar>







<mat-menu x-position="before" #menu="matMenu">
<button mat-menu-item routerLink="/">
	<mat-icon>home</mat-icon>
	Home
</button>

<button mat-menu-item routerLink="/game">
	<mat-icon>gamepad</mat-icon>
	Play
</button>
<button mat-menu-item routerLink="/login" *ngIf="!isAuthenticated">
	<mat-icon>power_settings_new</mat-icon>
	Login
</button>

<button mat-menu-item *ngIf="isAuthenticated" (click)="logout()">
	<mat-icon>exit_to_app</mat-icon>
	Logout
</button>
</mat-menu>


<mat-menu x-position="before" #matMenuAfterLogin="matMenu">
	<button mat-menu-item>
		Welcome {{name}}
	</button>
	<button mat-menu-item routerLink="/changePassword">
		<mat-icon>home</mat-icon>
		Change Password
	</button>
	<button mat-menu-item *ngIf="isAuthenticated" (click)="logout()">
		<mat-icon>power_settings_new</mat-icon>
		Logout
	</button>
</mat-menu>